import { useSyncExternalStore } from "react";

const QUERY = "(prefers-reduced-motion: reduce)";
const subscribe = (onChange) => {
  const media = window.matchMedia(QUERY);
  media.addEventListener("change", onChange);
  return () => media.removeEventListener("change", onChange);
};
const getSnapshot = () => window.matchMedia(QUERY).matches;
const getServerSnapshot = () => true;

// React to preference changes as they happen, including during a transition.
export const useReducedMotionPreference = () => useSyncExternalStore(subscribe, getSnapshot, getServerSnapshot);